import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {Subscription} from "@/entity/Subscription";

export const getMySubscription = async () => {
  const result = await apiBase.get(`/subscription`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((s) => { return new Subscription(s) })
}

export const isAvailableMySubscription = async () => {
  const result = await apiBase.get(`/subscription/available`, {})
  return camelcaseKeys(result.data.data, { deep: true })
}

export const hasSubscription = async ({ id }) => {
  const result = await apiBase.get(`/subscription/user/${id}`, {})
  return camelcaseKeys(result.data.data, { deep: true })
}
